import { render, staticRenderFns } from "./MainFilter.vue?vue&type=template&id=24bad3c1&scoped=true"
import script from "./MainFilter.vue?vue&type=script&lang=js"
export * from "./MainFilter.vue?vue&type=script&lang=js"
import style0 from "./MainFilter.vue?vue&type=style&index=0&id=24bad3c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bad3c1",
  null
  
)

export default component.exports